import { percentageOfInterval } from './percentageOfInterval';
import { Interval } from '../types';

export function getIntervalPositionWithinInterval(
    pelletInterval: Interval<Date>,
    timelineInterval: Interval<Date>,
) {
    const left = percentageOfInterval(pelletInterval.start, timelineInterval);
    const right = 1 - percentageOfInterval(pelletInterval.end, timelineInterval);

    return { left, right };
}
